/**
 * 書籍ページのメタ情報
 * slugをキーとして、タイトルと説明文を管理
 * 実際の紹介文はコンポーネント側で定義
 */
export type BookPage = {
  slug: string;
  date: string;
  title: string;
  description: string;
  category: string;
  hidden?: boolean;
};

/**
 * 書籍ページデータ
 * トップページのカード表示とメタデータ生成に使用
 */
export const BOOK_PAGES: Record<string, BookPage> = {
  "improvement-turnover-rate": {
    slug: "improvement-turnover-rate",
    date: "2026.2.19",
    title: "上達のコツは回転率！手塚治虫先生やマーク・ザッカーバーグ氏から学ぶ、創作能力を高める近道",
    description: "創作活動が上達するには、長編にじっくり取り組むのがよいのでしょうか？それとも短編を高スパンで仕上げていく方がよいのでしょうか？この記事では、漫画の神様である手塚治虫先生や、Meta（旧Facebook）のマーク・ザッカーバーグ氏の言葉をヒントにどちらがよいのかを考えた記事になります",
    category: "創作のヒント",
  },
  "book-stand": {
    slug: "book-stand",
    date: "2026.02.10",
    title: "もう猫背にならない！クランプ式ブックスタンドで叶える「省スペース化」と「正しい姿勢」",
    description: "デスクの狭さと猫背に悩む方へ。クランプ式ブックスタンドなら、デスク上のスペースを一切潰さずに本や資料を最適な目線の高さに固定できます。「机が狭い」「首が疲れる」を同時に解消し、集中力が続く作業環境を整えることができます。",
    category: "創作環境",
  },
  "clip-studio-tabmate-2": {
    slug: "clip-studio-tabmate-2",
    date: "2026.02.08",
    title: "CLIP STUDIO TABMATE 2レビュー｜左手デバイスを導入してみた感想",
    description: "CLIP STUDIO PAINT（クリスタ）を使用している筆者が、初の左手デバイスとしてCLIP STUDIO TABMATE 2を使ってみた感想レビューです。",
    category: "創作環境",
  },
  "felt-desk-mat": {
    slug: "felt-desk-mat",
    date: "2026.02.07",
    title: "フェルト素材のデスクマットを導入したら作業環境が想像より良くなった話【実体験レビュー】",
    description: "フェルト製デスクマットを実際に使用してみた感想記事です。使用前には想定していなかった思わぬメリットも！",
    category: "創作環境",
  },
  "wide-clamp-light": {
    slug: "wide-clamp-light",
    date: "2026.02.06",
    title: "デスクライト選びで作業効率が変わる！クランプ式ワイドライトを実際に使ってみた感想",
    description: "クランプ式とは、机の天板に挟んで設置するタイプのもので、ワイドライトとは光源部分が横長のライトのことです。本記事ではこのタイプのライトの魅力をご紹介しています",
    category: "創作環境",
  },
  "kindle-vs-fire": {
    slug: "kindle-vs-fire",
    date: "2026.02.05",
    title: "『Amazon Kindle タブレット』と『Fire HD タブレット』、読書に最適なのはどっち？",
    description: "電子書籍用のタブレットとして、筆者の体験から比較してどちらがお勧めかまとめた記事になります。結論からいうと圧倒的に「Fire HD タブレット」を推しています。購入を検討中の方は参考にしてみてください",
    category: "創作環境",
  },
  "growth-and-stop": {
    slug: "growth-and-stop",
    date: "2026.1.28",
    title: "成長は立ち止まるときにおこる？自分を飛躍させる俯瞰の時間",
    description: "今回は、創作術というよりも、成長そのものについての気づきになることをお伝えしたいと思います。この記事を読んでくださっている創作者の方々にとって、日々の創作活動における成長のヒントになれば幸いです。",
    category: "創作のヒント",
  },
  "narratology-and-decomposition": {
    slug: "narratology-and-decomposition",
    date: "2026.1.28",
    title: "物語は「何を書くか」と「どう書くか」で分けられる。「分解思考」による物語性の高め方",
    description: "何においてもそうですが、物事は分解すると考えやすくなる性質があります。今回は物語論を参考に物語を要素として分解し、分解することによる創作上の効果を考えてみたいと思います",
    category: "創作のヒント",
  },
  "the-matrix-and-monsters-inc": {
    slug: "the-matrix-and-monsters-inc",
    date: "2026.1.28",
    title: "『マトリックス』と『モンスターズ・インク』が同じ映画？ハリウッドのプロ脚本家が教える物語の骨格",
    description: "ハードSFアクションの金字塔「マトリックス」と、ディズニー/ピクサーの心温まるファンタジー「モンスターズ・インク」。この2作品が「同じ映画」だと言われて、あなたは信じられるでしょうか。この記事では物語のひな型という観点で、両作品の共通点を考えていきたいと思います",
    category: "創作のヒント",
  },
    "an-experience-that-you-cant-help-but-do": {
    slug: "an-experience-that-you-cant-help-but-do",
    date: "2026.01.27",
    title: "「ついやってしまう」体験のつくりかた。ゲームデザインから学ぶ人の心を動かす技術",
    description:
      "wiiの企画にも携わっていた元任天堂社員の玉樹真一郎氏の著書『「ついやってしまう」体験のつくりかた 人を動かす「直感・驚き・物語」のしくみ』から、人の心を動かす方法について学ぶ記事です。本書はゲーム設計を中心としたものですが、ゲームプランナーの他、脚本家や漫画家等の創作者にとっても学びのある1冊となっています",
    category: "創作のヒント",
  },
    "reward-discovery-circuit": {
    slug: "reward-discovery-circuit",
    date: "2026.01.22",
    title: "任天堂switchの生みの親、岩田さんが語る”自分の得意なものの見つけ方”",
    description:
      "2026年1月時点で世界累計販売台数2位を記録している大人気ゲーム機switch。この生みの親である岩田さんの言葉をまとめた書籍「岩田さん 岩田聡はこんなことを話していた。」の中で、岩田さんは、自分の得意なものを見つけるヒントとなる言葉を述べています。今回の記事は、富樫先生や岸本先生のエピソードも混ぜながら、そんな自分の得意なものを見つけるヒントとなる記事を作成しようと思います",
    category: "創作のヒント",
  },
    "fish-out-of-water": {
    slug: "fish-out-of-water",
    date: "2026.01.22",
    title: "映画手法における“場違いな人（Fish Out of Water）”とは？設定で興味を湧かせる古典的脚本手法と脳科学からみた効果",
    description:
      "古典的な映画手法として、“場違いな人（Fish Out of Water）”と呼ばれるものがあります。今回の記事では、この手法はどういったものなのか、どんな作品で活用されているのか。また、脳科学からみたこの手法の有用性について、紹介していきます",
    category: "創作のヒント",
  },
    "golden-fleece": {
    slug: "golden-fleece",
    date: "2026.01.21",
    title: "ストーリージャンル『金の羊毛』とは？ブレイク・スナイダー氏が語る“真の成長物語”の描き方",
    description:
      "有名脚本家のブレイク・スナイダー氏が著書「SAVE THE CATの法則 本当に売れる脚本術」で言及していた「金の羊毛」というストーリージャンルについて解説した記事です。本書では記載されていなかったこのジャンルに沿う作品も、ご紹介しています！",
    category: "創作のヒント",
  },
  "input-posture": {
    slug: "input-posture",
    date: "2026.01.20",
    title: "「色んな作品を『一回観た』って蓋をしちゃう人達は…」富樫先生が語る作家としてのインプットの姿勢",
    description:
      "富樫先生が語る創作者としてのインプットのあり方についてまとめた記事です。富樫先生や岸本先生が繰り返し観てきた映画についても紹介しています",
    category: "創作のヒント",
  },
  "interact-with-characters": {
    slug: "interact-with-characters",
    date: "2026.01.14",
    title: "キャラクターとの対話の重要性！小池和夫先生や富樫先生、荒木飛呂彦先生も語るキャラクターを深堀りするために必要なこと",
    description:
      "キャラクター作成でキャラクターとの対話の重要性に言及している書籍のご紹介",
    category: "創作のヒント",
  },
  "engeki-nyumon": {
    slug: "engeki-nyumon",
    date: "2026.01.10",
    title: "「美術館はいいなあ」がNGな理由とは？『演劇入門』に学ぶリアルなセリフの作り方",
    description:
      "戯曲を書くと言う視点から演劇をとらえた入門書『演劇入門』のご紹介",
    category: "創作のヒント",
  },
  "hetappi-manga-kenkyujyo-r": {
    slug: "hetappi-manga-kenkyujyo-r",
    date: "2026.01.08",
    title: "富樫義博先生が「物語に没入できなくなる覚悟」で行った訓練とは？『ヘタッピマンガ研究所R』から学ぶストーリー作成力の鍛え方",
    description:
      "ジャンプ公認「マンガの描き方」マンガ登場!!　河下水希先生、島袋光年先生、冨樫義博先生など超人気ジャンプ作家へのインタビューも収録されている『ヘタッピマンガ研究所R』のご紹介",
    category: "創作のヒント",
  },
  "arakihirohiko-no-mangajyutu": {
    slug: "arakihirohiko-no-mangajyutu",
    date: "2026.01.06",
    title: "漫画の「考え方」を学ぶ重要性──『荒木飛呂彦の漫画術』が教えてくれること",
    description:
      "『ジョジョの奇妙な冒険』の作者、荒木飛呂彦先生が執筆した漫画術に関する1冊、『荒木飛呂彦の漫画術』のご紹介",
    category: "創作のヒント",
  },
  "mangaka-eiga-wo-kataru": {
    slug: "mangaka-eiga-wo-kataru",
    date: "2026.01.05",
    title: "人気作を真似しても面白い漫画は描けない？—9人の鬼才が教える「本質を学ぶ」創作術",
    description:
      "『銀河鉄道999』から『進撃の巨人』まで。人気漫画家たちが語る、創作と映画の関係性とは—",
    category: "創作のヒント",
  },
  "tmp-aff": {  // テスト用
    slug: "tmp-aff",
    date: "xxxx.xx.xx",
    title: "創作秘話と別分野からみた分析手法",
    description: "",
    category: "創作のヒント",
    hidden: true,
  },
};

/**
 * 全書籍ページのスラッグ一覧を取得
 */
export const getAllBookPageSlugs = (): string[] => {
  return Object.keys(BOOK_PAGES);
};

/**
 * スラッグから書籍ページ情報を取得
 */
export const getBookPageBySlug = (slug: string): BookPage | undefined => {
  return BOOK_PAGES[slug];
};

/**
 * 全書籍ページ情報を配列で取得（トップページ表示用）
 */
export const getAllBookPages = (): BookPage[] => {
  return Object.values(BOOK_PAGES).filter((page) => !page.hidden);
};
